import { IonButton, IonIcon } from '@ionic/react';
import { star } from 'ionicons/icons';
import React from 'react';
import styled from 'styled-components';

const Content = styled.div`
  display: flex;
  padding: 20px 0;
`;

const Button = styled(IonButton).attrs({
  fill: 'clear',
})`
  --padding-end: 0px;
  --padding-start: 0;
  margin-right: 10px;

  :last-of-type {
    margin-right: 0;
  }
  &[disabled] {
    opacity: 1;
  }
`;

const Star = styled(IonIcon).attrs({
  icon: star,
})<{ $filled: boolean }>`
  width: 33px;
  height: 33px;
  color: ${({ $filled }) => ($filled ? ' #fdc40c' : '#989AA2')};
`;

const VALUES = [1, 2, 3, 4, 5];

type Props = {
  value?: number | null;
  readonly?: boolean;
  onIonChange?: (value: number | null) => void;
};

const Rating = ({ value, readonly = false, onIonChange }: Props) => {
  const onClick = (selected: number) => {
    let newValue: number | null = selected;
    if (!newValue || newValue < 1) {
      newValue = null;
    } else if (newValue > 5) {
      newValue = 5;
    }
    onIonChange?.(newValue);
  };

  return (
    <Content>
      {VALUES.map(val => (
        <Button
          key={val}
          data-testid={`rating-${val}`}
          onClick={() => onClick(val)}
          disabled={readonly}
        >
          <Star $filled={!!value && val <= value} />
        </Button>
      ))}
    </Content>
  );
};

export default Rating;
